import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import Landing from "@/pages/Landing";

export default function HomeGate() {
  const { user } = useAuth();
  const [pub, setPub] = useState(null);
  useEffect(() => {
    api.get("/public/settings").then((r) => setPub(!!r.data.homepage_public)).catch(() => setPub(false));
  }, []);
  if (pub === null || user === null) return <div className="min-h-screen bg-black" />;
  if (pub || user?.role === "admin") return <Landing />;
  return <Navigate to="/login" replace />;
}
